// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupItem_container__1baCp","item":"GroupItem_item__1q2Q4","button":"GroupItem_button__2nC8l","detailsBtn":"GroupItem_detailsBtn__16vih"};